import styles from "./commonStyles";

const CommonButton = ({
  formik,
  field,
  value,
  title,
  disabled,
  checkedColor,
  className = "",
}) => {
  return (
   <div className={`col-6 ${className}`}>
      <button
        className={`btn w-100 d-flex align-items-center justify-content-center fontSize16Medium commonButtonPadding button_green change-button ${
          formik?.values[field] !== value
            ? "change-button"
            : "change-button-green"
        }`}
        onClick={() => {
          formik.setFieldValue(field, value);
        }}
        disabled={disabled}
        style={{
          ...styles.common_border_styles,
          border: "1px solid #00DF99",
          borderRadius: "12px",
        }}
      >
        {title}
      </button>
      {/* {formik?.touched[field] && formik?.errors[field] && (
        <div className="text-danger mt-1">{formik?.errors[field]}</div>
      )} */}
    </div>
  );
};

export default CommonButton;
